/** Centralized route paths for the Collections feature. */
export const COLLECTION_ROUTES = {
    list: '/catalog/collections',
    new: '/catalog/collections/new',
    edit: (id: number) => ['/catalog/collections/edit', id],
    navigation: '/catalog/navigation',
} as const;

/** Same flag as the product Online listing panel, kept here so the shell need not load that panel's config. */
export const COLLECTIONS_FLAG = 'catalogOnlineStore';
